import { FC } from 'react';
import { UseFormRegister, FieldErrors, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { PropertyFormData } from '@/types/index';
import { RadioGroup } from '@components/common/RadioGroup';
import { Counter } from '@components/common/Counter';


interface Step2AnnexesProps {
  register: UseFormRegister<PropertyFormData>;
  errors: FieldErrors<PropertyFormData>;
  setValue: UseFormSetValue<PropertyFormData>;
  watch: UseFormWatch<PropertyFormData>;
}

export const Step2Annexes: FC<Step2AnnexesProps> = ({
  register: _register,
  errors,
  setValue,
  watch,
}) => {
  const hasCellar = watch('hasCellar') || false;
  const hasAttic = watch('hasAttic') || false;
  const coveredParkingCount = watch('coveredParkingCount') || 0;
  const uncoveredParkingCount = watch('uncoveredParkingCount') || 0;
  const hasIndividualGarage = watch('hasIndividualGarage') || false;

  // Total parking places
  const totalParkingPlaces = coveredParkingCount + uncoveredParkingCount;

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
        Annexes
      </h2>

      {/* Section Cave et Grenier */}
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <RadioGroup
            label="Cave"
            name="hasCellar"
            options={[
              { value: 'false', label: 'Non' },
              { value: 'true', label: 'Oui' },
            ]}
            value={String(hasCellar)}
            onChange={(value) => setValue('hasCellar', value === 'true')}
            layout="horizontal"
          />

          <RadioGroup
            label="Grenier"
            name="hasAttic"
            options={[
              { value: 'false', label: 'Non' },
              { value: 'true', label: 'Oui' },
            ]}
            value={String(hasAttic)}
            onChange={(value) => setValue('hasAttic', value === 'true')}
            layout="horizontal"
          />
        </div>
      </div>

      {/* Section Stationnements */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
          Stationnements
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Counter
            label="Places de stationnement couvertes"
            value={coveredParkingCount}
            onChange={(value) => setValue('coveredParkingCount', value)}
            min={0}
            max={10}
            error={errors.coveredParkingCount?.message}
          />

          <Counter
            label="Places de stationnement découvertes"
            value={uncoveredParkingCount}
            onChange={(value) => setValue('uncoveredParkingCount', value)}
            min={0}
            max={10}
            error={errors.uncoveredParkingCount?.message}
          />
        </div>

        {/* Type de parking - affiché seulement si places > 0 */}
        {totalParkingPlaces > 0 && (
          <RadioGroup
            label="Garage individuel"
            name="hasIndividualGarage"
            options={[
              { value: 'false', label: 'Non' },
              { value: 'true', label: 'Oui' },
            ]}
            value={String(hasIndividualGarage)}
            onChange={(value) => setValue('hasIndividualGarage', value === 'true')}
            layout="horizontal"
          />
        )}
      </div>
    </div>
  );
};
